import config from "../config";
import { authHeader, getHost } from "../helpers";

const getCompanySettings = () => {
  const requestOptions = {
    method: "GET",
    headers: authHeader(),
  };
  return fetch(
    `${config.atsApiUrl}/company/companySettings`,
    requestOptions
  ).then(handleResponse);
};

const updateCompanyProfile = (createData) => {
  const formData = new FormData();

  for (const name in createData) {
    if (name === "navBars") {
      if (createData[name] && createData[name].length > 0) {
        const finArr = [];
        createData[name].forEach((ele) => {
          if (ele?.text && ele?.link) {
            finArr.push(ele);
          }
        });
        formData.append(name, JSON.stringify(finArr));
      }
    } else {
      formData.append(name, createData[name]);
    }
  }
  const requestOptions = {
    method: "PUT",
    headers: {
      ...authHeader(),
    },
    body: formData,
  };

  return fetch(
    `${config.atsApiUrl}/company/companySettings`,
    requestOptions
  ).then(handleResponse);
};

const getCompanyPage = () => {
  const requestOptions = {
    method: "GET",
  };
  return fetch(
    `${config.atsApiUrl}/careers/info`,
    requestOptions
  ).then(handleResponse);
};

const getPageJob = (query) => {
  const host = getHost(window.location.hostname);
  const requestOptions = {
    method: "GET",
  };
  if (query) {
    return fetch(
      `${config.atsApiUrl}/careers/jobs?host=${host}&${new URLSearchParams(
        query
      )}`,
      requestOptions
    ).then(handleResponse);
  } else {
    return fetch(
      `${config.atsApiUrl}/careers/jobs?host=${host}`,
      requestOptions
    ).then(handleResponse);
  }
};

const handleResponse = (response) => {
  return response.text().then((text) => {
    const data = text && JSON.parse(text);
    if (!response.ok) {
      const error = (data && data.message) || response.statusText;
      if (response.status == 401) {
        localStorage.clear();
        window.location.pathname = "/";
      }
      return Promise.reject(error);
    }

    return data;
  });
};

export const CompanyService = {
  getCompanySettings,
  updateCompanyProfile,
  getCompanyPage,
  getPageJob,
};
